/**
 * TanStack Query hooks for `real-time-dns-cname-propagation-without-48hr-wait`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeDnsCnamePropagationWithout48hrWaitQueryKeys,
	type CreateRealTimeDnsCnamePropagationWithout48hrWaitBody,
	type ListRealTimeDnsCnamePropagationWithout48hrWaitResponse,
	type RealTimeDnsCnamePropagationWithout48hrWaitRow,
} from "./api";

export function useRealTimeDnsCnamePropagationWithout48hrWaitList(): UseQueryResult<ListRealTimeDnsCnamePropagationWithout48hrWaitResponse, Error> {
	return useQuery({
		queryKey: realTimeDnsCnamePropagationWithout48hrWaitQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeDnsCnamePropagationWithout48hrWaitCreate(): UseMutationResult<RealTimeDnsCnamePropagationWithout48hrWaitRow, Error, CreateRealTimeDnsCnamePropagationWithout48hrWaitBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeDnsCnamePropagationWithout48hrWaitQueryKeys.all });
		},
	});
}

export function useRealTimeDnsCnamePropagationWithout48hrWaitDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeDnsCnamePropagationWithout48hrWaitQueryKeys.all });
		},
	});
}
